import './policies.less'
import m from 'mithril'
import Layout from 'views/layout'
import {WysiwygType} from 'types/types'
import {action, Image, classes} from '@codeurs/front'
import Wysiwyg from 'views/layout/wysiwyg'
import ContentContainer from 'views/layout/contentcontainer'
import bigArrow from 'assets/icons/homearrow.svg'

type DomainType = {
	title: string
	description: WysiwygType
	url: string
}

type CategoryType = {
	title: string
	text: WysiwygType
	items: Array<DomainType>
}

export default class Policies extends Layout<{
	categories: Array<CategoryType>
}> {
	view() {
		const {categories} = this.attrs.data
		return m(ContentContainer,
			m('.policies', categories.map(cat => this.viewCategory(cat)))
		)
	}

	viewCategory(category: CategoryType) {
		return m('.policies-category', [
			m('.policies-category-header', [
				m('h2.policies-category-header-title', category.title),
				m('.policies-category-header-text', m(Wysiwyg, {html: category.text}))
			]),
			m('.policies-category-items',
				category.items.map(item => this.viewDomain(item))
			)
		])
	}

	viewDomain(domain: DomainType) {
		return m('a.policies-domain',
			{
				...action(domain.url)
			},
			[
				m('h3.policies-domain-title', domain.title),
				m('.policies-domain-text', m(Wysiwyg, {html: domain.description})),
				m('.policies-domain-container',
					m(Image, {
						src: bigArrow,
						alt: 'Go to policy',
						...classes('policies-domain-container-arrow', 'icon-arrow')
					})
				)
			]
		)
	}
}
